import clsx from 'clsx';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { Link as RouterLink } from 'react-router-dom';
import menu2Fill from '@iconify-icons/eva/menu-2-fill';
import { alpha, makeStyles } from '@material-ui/core/styles';
import Logo from 'src/components/Logo';
import { useSelector } from 'react-redux';
import {
  Box,
  AppBar,
  Hidden,
  Toolbar,
  IconButton,
  Typography,
  Link
} from '@material-ui/core';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    backdropFilter: 'blur(8px)',
    backgroundColor: alpha(theme.palette.background.default, 0.72),
    [theme.breakpoints.up('lg')]: {
      paddingLeft: DRAWER_WIDTH
    }
  },
  toolbar: {
    minHeight: APPBAR_MOBILE,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 5)
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: APPBAR_DESKTOP
    }
  }
}));

// ----------------------------------------------------------------------

TopBar.propTypes = {
  onOpenNav: PropTypes.func,
  className: PropTypes.string
};

function TopBar({ onOpenNav, className }) {
  const globalState = useSelector((state) => state.globalState);
  const configs = useSelector((state) => state.globalState.allConfigs);
  const [selectedView, setSelectedView] = useState('');

  useEffect(() => {
    if (globalState) {
      setSelectedView(globalState.tobarheading);
    }
  }, [globalState]);

  const classes = useStyles();

  return (
    <AppBar className={clsx(classes.root, className)}>
      <Toolbar className={classes.toolbar}>
        <Hidden lgUp>
          <Box
            component="div"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            style={{ width: '100%' }}
          >
            <IconButton
              onClick={onOpenNav}
              sx={{
                mr: 1,
                color: 'text.primary'
              }}
            >
              <Icon icon={menu2Fill} />
            </IconButton>
            <Typography variant="body1">{selectedView}</Typography>
            {globalState.clientID ? (
              <Link
                underline="none"
                component={RouterLink}
                // to={`/app/${globalState.clientID}/${
                //   configs['UI Config'].lead_card_info.default_view ||
                //   'UI_DefaultView'
                // }`}
                to={`/crm/${globalState.clientID}/${
                  configs['UI Config'].lead_card_info.default_view ||
                  'UI_DefaultView'
                }`}
              >
                <Logo />
              </Link>
            ) : (
              <Logo />
            )}
          </Box>
        </Hidden>

        <Hidden lgDown>
          <Typography variant="body1">{selectedView}</Typography>
        </Hidden>

        <Box sx={{ flexGrow: 1 }} />

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            '& > *:not(:first-of-type)': {
              ml: {
                xs: 0.5,
                sm: 2,
                lg: 3
              }
            }
          }}
        ></Box>
      </Toolbar>
    </AppBar>
  );
}

export default TopBar;
